module.exports = __webpack_public_path__ + "build/css/styles-all.css";